/**
 * TODO: in some future PR, implement mobile GA logging of custom events.
 * For now, just provide the same basic export interface as Desktop to prevent any import errors.
 */
export const logActionGA = () => {};

export const logDownloadGA = () => {};

export const logPrintGA = () => {};
